import type { FC } from 'react';
import { AnalysisPage } from '../../pages/AnalysisPage';

export const ReviewSheetAnalysisPage: FC = () => {
  return <AnalysisPage sheetType="RS" />;
};
